import { actions } from '..';
import * as apiQueue from '../../api/queue-control';
import { fetchTweetResponse } from '../actions';
import { selectMyself } from '../reducers/config';
import { getTweetById } from '../reducers/twitter';
import { all } from 'async-saga';
import { takeEvery } from '../tools/async-saga-types';

const onSendTweet = takeEvery(actions.sendTweet, async (ctx, { tweeterId, accountId, text, queueId }) => {
  const myself = selectMyself(ctx.getState())
  if (myself) {
    const result = await apiQueue.sendTweet(tweeterId, accountId, text, queueId)
    if (result.success) {
      ctx.dispatch(actions.showClientNotification('Tweet sent'))

      ctx.dispatch(actions.sentTweet(tweeterId, text, result.tweetId, myself.id))
    } else {
      ctx.dispatch(actions.showClientNotification('Tweet was not sent'))
    }
  }
})

const fetchTweetRequest = takeEvery(actions.fetchTweetRequest, async function (ctx, { tweetId, queueId, reply }) {
  const tweet = getTweetById(ctx.getState(), tweetId)

  if (!tweet) {
    const t = await apiQueue.requestTweetData(tweetId, queueId, reply)
    ctx.dispatch(fetchTweetResponse(t))
  }
})

export default all(
  onSendTweet,
  fetchTweetRequest,
)
